import jmespath from "jmespath";

export const getUniquePropertyValues = (geojson, key) => {
	const properties = jmespath.search(geojson.features, "[*].properties");
	return [...new Set(jmespath.search(properties, `[].${key}`))];
};
